import React from 'react';
import { Grid, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Widget from '../components/common/Widget';
import AddGuestForm from '../components/forms/AddGuestForm';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: [theme.spacing(2)],
    },
    maxWidth: 700,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

export default function Home() {
  const classes = useStyles();

  return (
    <>
      <Grid item xs={12}>
        <Widget />
        <Box className={classes.root}>
          <AddGuestForm hideCompanyCode />
        </Box>
      </Grid>
    </>
  );
}
